import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Modal, Button, Spinner, FormControl } from "react-bootstrap"
import ReactQuill from "react-quill-v2.0"
import AxiosConfig from "../../../../../../../utilities/AxiosConfig"
import reggie from "../../../../../../../utilities/Reggie"
import snackBar from "../../../../../../../utilities/snackBar/SnackBar"
import IncidentTimelineTypes from "../../../../../Types/IncidentTimelineTypes"
import "./IncidentTimelineTextEditor.css"

interface Props {
    toggleTextEditor: Function
    refreshTimeline: Function
    IncidentTimelineTypeId: number
    userId: string | number
    WorkersCompensationIncidentId: number
    IncidentTimelineId?: number
    item?: IncidentTimelineTypes
}

type State = {
    input: string
    title: string
    dirty: boolean
    saving: boolean
}

class IncidentTimelineTextEditor extends Component<Props, State> {


    formats = [
        "font", "color",
        "header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link"
    ]


    state = {
        input: "",
        title: "",
        dirty: false,
        saving: false
    }

    reference = [
        { id: 1, text: "Document" },
        { id: 2, text: "Correspondence" },
        { id: 3, text: "Note" },
        { id: 4, text: "Event" },
        { id: 5, text: "Form" },
        { id: 6, text: "Activity" },
    ]

    componentDidMount() {
        if (this.props.item) {
            this.setState({ title: this.props.item.TimelineTitle, input: this.props.item.NoteText })
        }
    }

    handleQuill = (input: string) => {
        this.setState({ input: input })
    }

    handleChange = (event: { target: { value: string } }) => {
        this.setState({ title: event.target.value })
    }

    createOrUpdateTimelineItem = () => {
        this.setState({ saving: true })
        const currTime = moment(Date.now()).toISOString()
        let rb: any = {
            IncidentTimelineId: this.props.IncidentTimelineId,
            IncidentId: this.props.WorkersCompensationIncidentId,
            IncidentTimelineTypeId: this.reference[this.props.IncidentTimelineTypeId - 1].id,
            TimelineTitle: this.state.title,
            TimelineDateUTC: currTime,
            LinkedToId: null,
            DeletedDateUTC: null,
            DeletedBy: null,
            DisabledDateUTC: null,
            DisabledBy: null,
            NoteText: this.state.input,
            IsLocked: false
        }

        if (this.props.item) {
            rb.LinkedToId = this.props.item.AttachmentId
            rb.ModifyDateUTC = currTime
            rb.ModifiedBy = this.props.userId
        } else {
            rb.CreatedDateUTC = currTime
            rb.CreatedBy = this.props.userId
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentTimelinePost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                if (!this.props.item) {
                    this.props.toggleTextEditor([{ key: "addEvent" }, { key: "addEventType" }])
                    snackBar({ type: "success", text: `${this.reference[this.props.IncidentTimelineTypeId - 1].text} added`, timeout: 3000 })
                } else {
                    this.props.toggleTextEditor([{ key: "edit" }, { key: "editIndex", value: -1 }])
                    snackBar({ type: "success", text: `${this.reference[this.props.IncidentTimelineTypeId - 1].text} edited`, timeout: 3000 })
                }
                this.props.refreshTimeline()
            }).catch(err => {
                //console.log(err)
                this.setState({ saving: false })
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
            })
    }

    render() {

        const canSave = reggie.filterTags(this.state.input) !== "" && this.state.title !== ""

        const hasTitle = this.state.title !== ""

        const props = this.props

        return (
            <Modal id="timeline-large-view-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="xl"
            >
                <Modal.Header>
                    <div className="IncidentTimelineTextEditorHeader">
                        <p>{this.props.item?.NoteText ? "Edit" : "Add"} {this.reference[this.props.IncidentTimelineTypeId - 1].text}</p>
                        <div className="IncidentTimelineTextEditorHeaderTitleWrapper">
                            <div className="IncidentTimelineTextEditorHeaderTitleWrapperLeft">
                                {hasTitle && <span id="incident-timeline-text-editor-title-wrapper-can-save" className="material-icons">done</span>}
                                {!hasTitle && <span id="incident-timeline-text-editor-title-wrapper-cant-save" className="material-icons">close</span>}
                            </div>
                            {props.IncidentTimelineTypeId !== 1
                                ? <div className="IncidentTimelineTextEditorHeaderTitleWrapperRight">

                                    <FormControl
                                        placeholder={`${this.reference[this.props.IncidentTimelineTypeId - 1].text} title`}
                                        aria-describedby="basic-addon1"
                                        onChange={this.handleChange}
                                        value={this.state.title}
                                    />

                                </div>
                                :
                                <div className="IncidentTimelineTextEditorHeaderTitleWrapperRightIsFile">
                                    <p>{this.state.title}</p>
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="IncidentTimelineTextEditorBody">
                        <ReactQuill
                            value={this.state.input}
                            onChange={this.handleQuill}
                            formats={this.formats}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="IncidentTimelineTextEditorFooter">
                        {!this.state.saving && !this.props.item && <Button variant="secondary" onClick={() => this.props.toggleTextEditor([{ key: "addEvent" }, { key: "addEventType" }])}>Back</Button>}
                        {!this.state.saving && this.props.item && <Button variant="secondary" onClick={() => this.props.toggleTextEditor([{ key: "edit" }, { key: "editIndex", value: -1 }])}>Back</Button>}
                        {!this.state.saving && canSave && <Button variant="primary" onClick={() => this.createOrUpdateTimelineItem()}>Save</Button>}
                        {this.state.saving && <Spinner id="incident-timeline-text-editor-save-spinner" animation="border" />}
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default IncidentTimelineTextEditor